import { render, staticRenderFns } from "./FormComment.vue?vue&type=template&id=758fc8b2&"
import script from "./FormComment.vue?vue&type=script&lang=js&"
export * from "./FormComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports